import type { ProfileData } from '../types';

export function mapToProfileData(apiResponse: any): ProfileData {
    const user = apiResponse?.user || {};
    const paymentDetails = apiResponse?.paymentDetails[0] || {};
    // const wallet = apiResponse?.wallet || {};

    return {
        _id: user._id || "",
        email: user.email || "",
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        phone: user.phone || "",
        dob: user.dob || "",
        address: user.address || "",
        profilePictureUrl: user?.profileImage?.url || "",
        bankName: paymentDetails.bank_name || "",
        bankAccountNumber: paymentDetails.account_number || "",
        bankAccountName: paymentDetails.account_name || "",
        wallet_address: paymentDetails.wallet_address || "",
        network: paymentDetails.network || "",
        kycDocumentType: user?.kycDocument?.idType || "",
        kycDocumentUrl: user?.kycDocument?.url || "",
        kycVerificationStatus: user?.kycDocument?.status || "",
        kycSubmittedAt: user?.kycDocument?.submittedAt || "",
        kycVerifiedAt: user?.kycDocument?.verifiedAt || "",
        payMethod: paymentDetails?.pay_type || "",
        token: paymentDetails?.coin || "",
        updatePasswordDate: user?.updatePasswordDate || "",
        createdAt: user?.createdAt || ""
    };
}
